import { useState, useRef } from "react"
import { Typography } from "@stardust-ds/react"

import styles from "./index.module.scss"
import MembersIcon from "../../../assets/icons/MembersIcon"
import EllipsisCardIcon from "../../../assets/icons/EllipsisCardIcon"
import useClickOutside from "../../../hooks/useClickOutside"

function RcmpCardHiddenUsers(props) {
    const { aUsers } = props
    const [bIsOpen, fnSetBisOpen] = useState(false)

    const elContainerRef = useRef(null)
    useClickOutside(elContainerRef, () => fnSetBisOpen(false))

    if (!aUsers?.length) return null

    const fnToggleShowUsers = (e) => {
        e.stopPropagation()
        fnSetBisOpen(!bIsOpen)
    }

    return (
        <div ref={elContainerRef} className={styles.containerHiddenUser}>
            <div className={styles.showHiddenUser} onClick={fnToggleShowUsers}>
                <EllipsisCardIcon fill="#6CB6E3" width="15px" heigth="20px" />
            </div>
            {bIsOpen && (
                <div className={styles.cardHiddenUsers}>
                    {aUsers?.map((oUser, nIndex) => (
                        <p key={nIndex}>{oUser?.user_cname}</p>
                    ))}
                </div>
            )}
        </div>
    )
}

function RcmpUser(props) {
    const { oUser } = props;

    const [bOpenToolTip, fnSetBOpenToolTip] = useState(false);

    if (!oUser) return null

    function fnOpenToolTip() {
        fnSetBOpenToolTip(true)
    }

    function fnCloseToolTip() {
        fnSetBOpenToolTip(false)
    }

    return (
        <div
            className={styles.userIconContainer}
            onMouseEnter={fnOpenToolTip}
            onMouseLeave={fnCloseToolTip}
        >
            {bOpenToolTip && (
                <div className={styles.floatContent} >
                    {oUser?.user_cname}
                </div>
            )}
            {oUser.user_cavatar ? (
                <img src={oUser.user_cavatar} />
            ) : (
                <MembersIcon />
            )}
        </div>
    )
}

export default function RcmpCardUsers(props) {
    const { cLabel, aUsers, bLarge, bSmall, className, ...oRest } = props

    const cClasses = `${styles.cardUsers} ${bLarge ? styles.cardUsersLg : ""} ${bSmall ? styles.cardUsersSm : ""} ${className ? className : ""}`
    const aFirstThreeUsers = aUsers?.length > 3 ? aUsers?.slice(0, 3) : aUsers
    const aHiddenUsers = aUsers?.slice(3) || []

    return (
        <div className={cClasses} {...oRest}>
            {cLabel && (
                <Typography color="#415364" type="h5">
                    {cLabel}
                </Typography>
            )}
            {aFirstThreeUsers?.map((oUser, nIndex) => (
                <RcmpUser key={nIndex} oUser={oUser} />
            ))}
            <RcmpCardHiddenUsers aUsers={aHiddenUsers} />
        </div>
    )
}
